let html = `<div class="season-episode-rate">
    <svg><use xlink:href="#sprite-star"></use></svg>
    <span>{rate}</span>
</div>`

export default html